import { useState } from "react";
import NotificationChannels from "./components/notification/NotificationChannels";
import AddNotificationChannel from "./components/notification/AddNotificationChannel";
import { useBreadcrumb } from "@/components/breadcrumbs";

const Notification = () => {
  const [showAddNotificationChannel, setShowAddNotificationChannel] = useState<boolean>(false);

  useBreadcrumb("Notifications", {
    defaultParents: [{ label: "Settings", pathname: "/settings", noLink: true }],
  });

  const toggleAddNotificationChannel = () => {
    setShowAddNotificationChannel(prev => !prev);
  };

  return (
    <>
      {showAddNotificationChannel ? (
        <AddNotificationChannel toggleAddNotificationChannel={toggleAddNotificationChannel} />
      ) : (
        <NotificationChannels toggleAddNotificationChannel={toggleAddNotificationChannel} />
      )}
    </>
  );
};

export default Notification;
